module.exports = __webpack_public_path__ + "2c39d6424f069282a0d71158fe76e440.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/advisory/Tu_Van_Phap_Ly_Doanh_Nghiep.svg
// module id = ./assets/images/advisory/Tu_Van_Phap_Ly_Doanh_Nghiep.svg
// module chunks = 0